import { STATES_ACT } from 'civil-status/constants/states-act';
import {
  ParentVM,
  RecapVM,
  SectionVM,
  StatoCivile,
  TextActVM,
} from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';

export const transformerStatoCivile = (
  data: Array<RecapVM>,
  idValore?: string,
  idEvento?: number,
  dateFormationAct?: string,
  subject?: ParentVM,
  valuesText?: TextActVM,
  dataDead?: SectionVM,
  dataMatrimonioAtti?: SectionVM,
  dataLawCitizenship?: SectionVM,
  dataDatiRegistroEmergenza?: SectionVM,
  isLastStepEmergency?: boolean,
  valuesDatiSpecificiCittadinanza?: SectionVM,
  dataCittadinanza?: SectionVM
): StatoCivile => {
  const date = dataDatiRegistroEmergenza?.effectiveDate?.toFormat('yyyy-MM-dd') || '';
  const hours = dataDatiRegistroEmergenza?.effectiveTime?.toFormat('THHmmssSSS') || '';
  const timestampDecorrenza =
    date || hours
      ? DateTime.fromFormat(`${date || ''} ${hours || ''}`, 'yyyy-MM-dd THHmmssSSS')
      : undefined;

  const lastItem = data[data.length - 1];
  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    tipoAtto: data[0]?.tipoAtto || undefined,
    // tipoEvento: data[0]?.response || undefined,
    tipoEvento: data[0]?.codStepSuccessivo || undefined,
    tipoContenuto: data[0]?.tipoContenuto || undefined,
    tipoUseCase: idValore || undefined,
    codiceStatoEvento: isLastStepEmergency
      ? STATES_ACT.ID_STATE_BOZZA_EMERGENZA
      : data[0]?.codiceStatoEvento || data[0]?.codStepSuccessivo || undefined,
    idAnsc: data[0]?.idAnsc || undefined,
    numeroAtto: data[0]?.numeroAtto || undefined,
    parteAtto: lastItem.parte || lastItem.responseData?.cdParte || undefined,
    serie1Atto: lastItem.serie1 || lastItem.responseData?.cdSerie1 || undefined,
    serie2Atto: lastItem.serie2 || lastItem.responseData?.cdSerie2 || undefined,
    dataFormazioneAtto: dateFormationAct || undefined,
    nascitaIstat:
      subject?.generality?.codeIstat?.id?.toString() || data[0]?.nascitaIstat || undefined,
    luogoEvento:
      subject?.generality?.birthPlaceItem?.id?.toString() || data[0]?.luogoEvento || undefined,
    tipoResidenzaNascituro:
      subject?.generality?.residenceId || data[0]?.tipoResidenzaNascituro || undefined,
    flagTestoEditabile: valuesText ? (valuesText.isEditText ? '1' : '0') : undefined,
    autorita: dataDead?.authority?.id?.toString() || undefined,
    codiceRito: dataMatrimonioAtti?.ritualReligious?.id?.toString() || undefined,
    idMotivoVariazioneCittadinanza: dataLawCitizenship?.numberLawCitizenship || undefined,
    idRdE: dataDatiRegistroEmergenza?.emergencyRegister?.id?.toString() || undefined,
    descRdE: dataDatiRegistroEmergenza?.emergencyRegister?.value || undefined,
    codMargineRdE: dataDatiRegistroEmergenza?.margin || undefined,
    timestampDecorrenza,
    numeroAttoRdE: dataDatiRegistroEmergenza?.number || undefined,
    flagResidenzaDaAltraDoc: valuesDatiSpecificiCittadinanza
      ? valuesDatiSpecificiCittadinanza.isResidencePresentationDocuments
        ? '1'
        : '0'
      : undefined,
    codiceTempisticaGiuramento: dataCittadinanza?.typeExtremesDecree || undefined,
    numeroPecRiammissione: dataCittadinanza?.extremesPec || undefined,
  };
};
